import React from 'react'

import GroupCard from './GroupCard'
import { useStyles } from './styles'

interface Props {
  groups: Group[]
}

const GroupsGrid: React.FunctionComponent<Props> = ({ groups }) => {
  const classes = useStyles()

  return (
    <div className={classes.gridList}>
      {groups.map(group => (
        <GroupCard key={group.id} group={group} />
      ))}
    </div>
  )
}

export default GroupsGrid
